import React from 'react';
import useTabs from "../../../hooks/useTabs";

const PickUpCard = ({viewJob}) => {
    const {activeTab, changeTab} = useTabs(0);
    const tabs = ['Pick-Up', 'Drop Off'];

    return (
        <>
            <div class="card">
                {/*<h6 class="card-header">*/}
                {/*    Pick Up*/}
                {/*</h6>*/}
                <div class="card-body">
                    <ul class="nav nav-fill nav-underline mb-4">
                        {tabs?.map((tab, index) => (
                            <li key={index} className="nav-item">
                                <a
                                    className={`nav-link rounded-0 ${activeTab === index ? 'active' : ''}`}
                                    type="button"
                                    onClick={() => changeTab(index)}
                                >
                                    {tab}
                                </a>
                            </li>
                        ))}
                    </ul>
                    {activeTab === 0 && (
                        <>
                            <div class="row g-3">
                                <div class="col-lg-6">
                                    <label className="card-title">
                                        Person Name: &nbsp;
                                        <span className="fw-normal">
                                                        {viewJob?.pickup_person_name}
                                                    </span>
                                    </label>
                                </div>
                                <div class="col-lg-6">
                                    <label className="card-title">
                                        Person Phone: &nbsp;
                                        <span className="fw-normal">
                                                        {viewJob?.pickup_person_phone}
                                                    </span>
                                    </label>
                                </div>
                                <div className="col-lg-12">
                                    <label className="card-title">
                                        Address: &nbsp;
                                        <span className="fw-normal">
                                                        {viewJob?.pickup_address}
                                                    </span>
                                    </label>
                                </div>
                                <div class="col-lg-6">
                                    <label className="card-title">
                                        Lat: &nbsp;
                                        <span className="fw-normal">
                                                        {viewJob?.pickup_latitude}
                                                    </span>
                                    </label>
                                </div>
                                <div class="col-lg-6">
                                    <label className="card-title">
                                        Lng: &nbsp;
                                        <span className="fw-normal">
                                                        {viewJob?.pickup_longitude}
                                                    </span>
                                    </label>
                                </div>
                            </div>
                        </>
                    )}
                    {activeTab === 1 && (
                        <>
                            <div class="row g-3">
                                <div class="col-lg-6">
                                    <label className="card-title">
                                        Person Name: &nbsp;
                                        <span className="fw-normal">
                                                        {viewJob?.drop_person_name}
                                                    </span>
                                    </label>
                                </div>
                                <div class="col-lg-6">
                                    <label className="card-title">
                                        Person Phone: &nbsp;
                                        <span className="fw-normal">
                                                        {viewJob?.drop_person_phone}
                                                    </span>
                                    </label>
                                </div>
                                <div class="col-lg-12">
                                    <label className="card-title">
                                        Address: &nbsp;
                                        <span className="fw-normal">
                                                        {viewJob?.drop_address}
                                                    </span>
                                    </label>
                                </div>
                                <div class="col-lg-6">
                                    <label className="card-title">
                                        Lat: &nbsp;
                                        <span className="fw-normal">
                                                        {viewJob?.drop_latitude}
                                                    </span>
                                    </label>
                                </div>
                                <div class="col-lg-6">
                                    <label className="card-title">
                                        Lng: &nbsp;
                                        <span className="fw-normal">
                                                        {viewJob?.drop_longitude}
                                                    </span>
                                    </label>
                                </div>
                            </div>
                        </>
                    )}

                </div>
            </div>
        </>
    );
};

export default PickUpCard;